import { createContext } from 'react';
import { identity } from 'ramda';

export const AppContext = createContext<{
    addLoadingPromise(promise?: Promise<any>): void;
}>({
    addLoadingPromise: identity
});
